import map from '../maplibre-main.vue'; // reuse your existing components
import selectedLocation from '../selectedLocation.vue';
import selectedProperty from '../selectedProperty.vue';
import mapDefault from '../mapDefault.vue';

export default [
    {
        path: '/',
        component: map,
        children: [
            {
                path: '',
                name: 'locations.map.index',
                component: mapDefault,
            },
            {
                path: 'prop/:slug',
                name: 'locations.map.showProp',
                component: selectedProperty,
                props: route => ({ mode: 'show', slug: route.params.slug }),
            },
            {
                path: ':slug',
                name: 'locations.map.show',
                component: selectedLocation,
                props: route => ({ mode: 'show', slug: route.params.slug }),
            },
        ],
    },
];